<!-- Header -->
<div
  class="md:px-4 px-3 py-3 flex align-items-center justify-content-between border-bottom-1 border-300 -mx-3 -mt-3"
  data-testid="tax-group-create-header"
>
  <div class="flex align-items-center" data-testid="header-title-container">
    <i class="fa fa-plus mr-2 text-500"></i>
    <h2 class="mb-0 text-sm" data-testid="tax-group-create-title">
      {{
        taxCategory
          ? ('ADMIN.TAX.EDIT_TAX_CATEGORY' | translate)
          : ('ADMIN.TAX.ADD_TAX_CATEGORY' | translate)
      }}
    </h2>
  </div>
  <div
    class="fa fa-times text-xl text-600 cursor-pointer"
    (click)="close()"
    aria-label="close-tax-group-dialog-button"
  ></div>
</div>
<!-- Header -->
@if (taxCategoryForm) {
  <form
    [formGroup]="taxCategoryForm"
    (ngSubmit)="saveTaxCategory()"
    data-testid="tax-group-form"
  >
    <!-- Content -->
    <div class="surface-100 p-4 text-sm -mx-3" data-testid="tax-group-content">
      <!-- Form Group -->
      <div class="mb-4">
        <label
          class="font-medium text-700 text-xs mb-2 block uppercase"
          data-testid="tax-group-name-primary-label"
        >
          {{ 'ADMIN.TAX.TAX_GROUP_NAME' | translate }}
          @if (isSecondaryLanguage) {
            <span>({{ primaryLanguage | translate }})</span>
          }
        </label>
        <input
          type="text"
          pInputText
          class="w-full text-sm"
          [placeholder]="'ADMIN.COMMON.NAME' | translate"
          formControlName="name_primary_language"
          aria-label="tax-group-name-primary-input"
          data-testid="tax-group-name-primary-input"
        />
        @if (CatNamePrimary?.touched && CatNamePrimary?.invalid) {
          <app-error-msg
            [errors]="CatNamePrimary?.errors"
            [fieldLabel]="'ADMIN.TAX.TAX_GROUP_NAME' | translate"
            data-testid="tax-group-name-primary-error"
          />
        }
      </div>
      <!-- Form Group -->
      <!-- Form Group -->
      @if (isSecondaryLanguage) {
        <div class="mb-1">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            data-testid="tax-group-name-secondary-label"
          >
            {{ 'ADMIN.TAX.TAX_GROUP_NAME' | translate }}
            @if (isSecondaryLanguage) {
              <span>({{ secondaryLanguage | translate }})</span>
            }
          </label>
          <input
            type="text"
            pInputText
            class="w-full text-sm"
            [placeholder]="'ADMIN.COMMON.NAME' | translate"
            formControlName="name_secondary_language"
            aria-label="tax-group-name-secondary-input"
            data-testid="tax-group-name-secondary-input"
          />
          @if (CatNameSecondary?.touched && CatNameSecondary?.invalid) {
            <app-error-msg
              [errors]="CatNameSecondary?.errors"
              [fieldLabel]="'ADMIN.TAX.TAX_GROUP_NAME' | translate"
              data-testid="tax-group-name-secondary-error"
            />
          }
        </div>
      }
      <!-- Form Group -->
    </div>
    <!-- Content -->
    <!-- Footer -->
    <div
      class="p-3 flex justify-content-between align-items-center border-top-1 border-300 -mx-3 -mb-3"
      data-testid="form-actions"
    >
      <button
        pButton
        pRipple
        type="button"
        [label]="'ADMIN.COMMON.CANCEL' | translate"
        class="p-button-text text-sm"
        (click)="close()"
        styleClass="text-sm"
        aria-label="cancel-tax-group-button"
        data-testid="cancel-tax-group-button"
      ></button>
      <button
        pButton
        pRipple
        type="submit"
        [label]="'ADMIN.COMMON.SAVE' | translate"
        class="text-sm"
        aria-label="save-tax-group-button"
        data-testid="save-tax-group-button"
      ></button>
    </div>
    <!-- Footer -->
  </form>
}

@if (showErrorPopup | async; as show_Popup) {
  <app-error-msg
    [visible]="show_Popup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [errorData]="[]"
    [error]="error"
    (hideErrorPopup)="HideErrorPopup($event)"
    data-testid="tax-group-error-popup"
  />
}
